import React from 'react';
import { AssignmentUserSelect } from './AssignmentUserSelect';
import { AssignmentActivityTable } from './AssignmentActivityTable';
import AssignmentMobileCompletedActivityTable from './AssignmentMobileCompletedActivityTable';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';

export const AssignmentMainSection = () => {
    const isPatientMessagingEnabled = useIsPermitted(PERMISSION_TYPES.PATIENT_MESSAGING_CONF);
    const isGenerateMobileLinkEnabled = useIsPermitted(PERMISSION_TYPES.GENERATE_MOBILE_LINK);

    return (
        <div>
            <AssignmentUserSelect />
            {(isPatientMessagingEnabled || isGenerateMobileLinkEnabled) && <AssignmentMobileCompletedActivityTable />}
            <AssignmentActivityTable />
        </div>
    );
};
